export default __webpack_public_path__ + "static/media/a3_landscape.a7b6ff8c.png";